angular.module('app.player.telestrate.telestrateCanvasController', [])
  .controller('app.player.telestrate.telestrateCanvasController', [
    '$scope',
    function ($scope) {
      "use strict";

      $scope.canvasContext = $scope.canvasContext || null;
      $scope.telestrateIsDrawing = false;
      //$scope.telestrateSmall = false;
      $scope.toolbox = $scope.toolbox || null;

      $scope.teleStrateStartDraw = function (evt) {
        //only start drawing if telestrate tab is active
        if ($scope.activeTab == $scope.telestrateTab) {

          //start of drawing, so flip to drawing mode
          $scope.telestrateIsDrawing = true;

          //setup the lastX and lastY here
          //used as origin in line drawing
          $scope.toolbox.lastX = evt.offsetX;
          $scope.toolbox.lastY = evt.offsetY;

          //bounce event to main draw function
          $scope.telestrateDraw(evt);
        }
      };

      $scope.telestrateEndDraw = function () {
        $scope.telestrateIsDrawing = false;
      };

      $scope.telestrateDraw = function (evt) {

        //mousemove calls this function, which means that many calls must be ignored
        //if user is not actively drawing on telestrator, therefore do nothing if
        //not in drawing mode
        if ($scope.telestrateIsDrawing) {

          if ($scope.toolbox.isClearing) {
            //clearRect used for eraser tool
            $scope.canvasContext.clearRect(evt.offsetX, evt.offsetY, $scope.toolbox.fillDiameter, $scope.toolbox.fillDiameter);
          } else {
            //set stroke & fill colouring
            $scope.canvasContext.fillStyle = $scope.toolbox.color;
            $scope.canvasContext.strokeStyle = $scope.toolbox.color;

            if ($scope.toolbox.lastX != evt.offsetX || $scope.toolbox.lastY != evt.offsetY) {

              //lineTo used for 2..n points that are to be drawn on telestrator mouse stroke
              $scope.canvasContext.beginPath();
              $scope.canvasContext.moveTo($scope.toolbox.lastX, $scope.toolbox.lastY);
              $scope.canvasContext.lineTo(evt.offsetX, evt.offsetY);
              $scope.canvasContext.lineWidth = $scope.toolbox.fillDiameter;
              $scope.canvasContext.stroke();

              //copy last mouse position for use in next line stroke
              $scope.toolbox.lastX = evt.offsetX;
              $scope.toolbox.lastY = evt.offsetY;

            } else {
              //fillRect used for 1st point drawn on telestrator brush stroke
              $scope.canvasContext.fillRect(evt.offsetX, evt.offsetY, $scope.toolbox.fillDiameter, $scope.toolbox.fillDiameter);
            }

          }

          // stop clicks from bubbling down to the player
          // but only if we're drawing - else pass through
          evt.stopPropagation();
        }
      };

      // let setSmallcanvas = function () {
      //   if (!$scope.telestrateSmall) {
      //     if($scope.canvas) {
      //       $scope.canvasContext.clearRect(0, 0, $scope.canvas.width, $scope.canvas.height);
      //       $scope.telestrateSmall = true;
      //       $scope.canvas.width = 320;
      //       $scope.canvas.height = 240;
      //     }
      //   }
      // };

      // let setLargeCanvas = function () {
      //   if ($scope.telestrateSmall) {
      //     if($scope.canvas) {
      //       $scope.canvasContext.clearRect(0, 0, $scope.canvas.width, $scope.canvas.height);
      //       $scope.telestrateSmall = false;
      //       $scope.canvas.width = 640;
      //       $scope.canvas.height = 440;
      //     }
      //   }
      // };

      let canvasResize = function () {
        //canvas container use since canvas does not exist yet
        let getCanvas = document.getElementById('tele-canvas');
        let playerWidth = getCanvas.offsetWidth;
        let playerHeight = playerWidth / 1.77777777778; //16:9 format
        //canvas element
        getCanvas.children["0"].width = playerWidth;
        getCanvas.children["0"].height = playerHeight;
      };

      let init = () => {
        
        canvasResize();

        // if ($(window).width() <= 660) {
        //   setSmallcanvas();
        // }
      };

      $(window).on("resize.doResize", _.debounce(function () {

        canvasResize();

        // let windowWidth = $(window).width();

        // if (windowWidth <= 660) {
        //   setSmallcanvas();
        // } else {
        //   setLargeCanvas();
        // }

      }, 100));  //debounce resolution 100ms

      $scope.$on("$destroy", function () {
        $(window).off("resize.doResize");
      });

      $scope.$watch(
        () => {
          return $scope.toolbox.clearCanvas;
        },
        () => {
          if ($scope.toolbox.clearCanvas && $scope.canvasContext) {
            $scope.canvasContext.clearRect(0, 0, $scope.canvas.width, $scope.canvas.height);
            $scope.toolbox.clearCanvas = false;
          }
        }
      );

      init();
    }
  ]);


// WEBPACK FOOTER //
// ./app.v2/components/player/telestrate/telestrateCanvas/telestrateCanvasController.js